export class Game {
  constructor (canvasId) {
    this.canvas = document.getElementById(canvasId)
    this.ctx = this.canvas.getContext('2d')
    this.carWidth = 30
    this.carHeight = 60
    this.roadWidth = 300
    this.initialGameSpeed = 2
    this.gameSpeed = this.initialGameSpeed
    this.carX = this.canvas.width / 2 - this.carWidth / 2
    this.carY = this.canvas.height - this.carHeight - 10
    this.obstacles = []
    this.coins = []
    this.obstacleWidth = 20
    this.obstacleHeight = 60
    this.coinWidth = 20 // Largeur de la pièce
    this.coinHeight = 30 // Hauteur de la pièce
    this.obstacleGap = 200 // Espace entre les obstacles
    this.isGameOver = false
    this.score = 0
    this.timeElapsed = 0 // Temps écoulé pour augmenter la difficulté

    this.carImage = new Image()
    this.carImage.src = '/app/themes/akyos-sage/resources/assets/images/car.png' // Chemin vers l'image de la voiture

    this.obstacleImage = new Image()
    this.obstacleImage.src = '/app/themes/akyos-sage/resources/assets/images/boy.png' // Chemin vers l'image de l'obstacle

    this.coinImage = new Image()
    this.coinImage.src = '/app/themes/akyos-sage/resources/assets/images/beer.png' // Chemin vers l'image du point

    this.keys = {
      left: false,
      right: false
    }

    this.init()
  }

  init () {
    this.initObstacles()
    this.initCoins()
    this.bindEvents()
    this.showStartScreen()
  }

  initObstacles () {
    for (let i = 0; i < 3; i++) {
      // Positionner les obstacles uniquement sur la route
      this.obstacles.push({
        x: this.canvas.width / 2 - this.roadWidth / 2 + Math.random() * (this.roadWidth - this.obstacleWidth),
        y: i * -this.obstacleGap
      })
    }
  }

  initCoins () {
    // Initialiser les pièces
    this.coins.push({
      x: this.canvas.width / 2 - this.roadWidth / 2 + Math.random() * (this.roadWidth - this.coinWidth),
      y: -Math.random() * this.obstacleGap // Positionner aléatoirement en haut de l'écran
    })
  }

  bindEvents () {
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        this.keys.left = true
      } else if (e.key === 'ArrowRight') {
        this.keys.right = true
      }
    })

    document.addEventListener('keyup', (e) => {
      if (e.key === 'ArrowLeft') {
        this.keys.left = false
      } else if (e.key === 'ArrowRight') {
        this.keys.right = false
      }
    })

    document.getElementById('startButton').addEventListener('click', () => {
      this.startGame()
    })

    document.getElementById('restartButton').addEventListener('click', () => {
      this.restartGame()
    })
  }

  showStartScreen () {
    document.getElementById('startScreen').style.display = 'block'
    document.getElementById('gameOverScreen').style.display = 'none'
    this.canvas.style.display = 'none'
  }

  startGame () {
    this.isGameOver = false
    this.score = 0
    this.obstacles = []
    this.coins = []
    this.carX = this.canvas.width / 2 - this.carWidth / 2
    this.carY = this.canvas.height - this.carHeight - 10
    this.gameSpeed = this.initialGameSpeed // Réinitialiser la vitesse du jeu
    this.timeElapsed = 0 // Réinitialiser le temps écoulé
    this.initObstacles()
    this.initCoins()
    document.getElementById('startScreen').style.display = 'none'
    this.canvas.style.display = 'block'
    this.gameLoop()
  }

  restartGame () {
    this.startGame()
  }

  drawCar () {
    this.ctx.drawImage(this.carImage, this.carX, this.carY, this.carWidth, this.carHeight)
  }

  drawRoad () {
    const roadX = this.canvas.width / 2 - this.roadWidth / 2

    // Route
    this.ctx.fillStyle = '#555'
    this.ctx.fillRect(roadX, 0, this.roadWidth, this.canvas.height)

    // Lignes médianes
    this.ctx.setLineDash([20, 15])
    this.ctx.strokeStyle = '#fff'
    this.ctx.lineWidth = 5
    this.ctx.beginPath()
    this.ctx.moveTo(this.canvas.width / 2, 0)
    this.ctx.lineTo(this.canvas.width / 2, this.canvas.height)
    this.ctx.stroke()
  }

  drawObstacles () {
    this.ctx.fillStyle = '#000'
    this.obstacles.forEach((obstacle) => {
      this.ctx.drawImage(this.obstacleImage, obstacle.x, obstacle.y, this.obstacleWidth, this.obstacleHeight)
    })
  }

  drawCoins () {
    this.coins.forEach((coin) => {
      this.ctx.drawImage(this.coinImage, coin.x, coin.y, this.coinWidth, this.coinHeight)
    })
  }

  moveObstacles () {
    this.obstacles.forEach((obstacle) => {
      obstacle.y += this.gameSpeed

      // Si l'obstacle sort de l'écran, le repositionner en haut
      if (obstacle.y > this.canvas.height) {
        obstacle.y = -this.obstacleGap
        obstacle.x = this.canvas.width / 2 - this.roadWidth / 2 + Math.random() * (this.roadWidth - this.obstacleWidth)
      }
    })
  }

  moveCoins () {
    this.coins.forEach((coin) => {
      coin.y += this.gameSpeed // Les pièces se déplacent avec la même vitesse que les obstacles

      // Si la pièce sort de l'écran, la repositionner
      if (coin.y > this.canvas.height) {
        coin.y = -Math.random() * this.obstacleGap // Réinitialiser à une position aléatoire
        coin.x = this.canvas.width / 2 - this.roadWidth / 2 + Math.random() * (this.roadWidth - this.coinWidth)
      }
    })
  }

  moveCar () {
    const moveSpeed = 5 // Vitesse de mouvement
    if (this.keys.left && this.carX > this.canvas.width / 2 - this.roadWidth / 2) {
      this.carX -= moveSpeed
    }
    if (this.keys.right && this.carX < this.canvas.width / 2 + this.roadWidth / 2 - this.carWidth) {
      this.carX += moveSpeed
    }
  }

  checkCollision () {
    this.obstacles.forEach((obstacle) => {
      if (
        this.carX < obstacle.x + this.obstacleWidth &&
        this.carX + this.carWidth > obstacle.x &&
        this.carY < obstacle.y + this.obstacleHeight &&
        this.carY + this.carHeight > obstacle.y
      ) {
        this.isGameOver = true
      }
    })

    this.coins.forEach((coin, index) => {
      if (
        this.carX < coin.x + this.coinWidth &&
        this.carX + this.carWidth > coin.x &&
        this.carY < coin.y + this.coinHeight &&
        this.carY + this.carHeight > coin.y
      ) {
        this.coins.splice(index, 1) // Retirer la pièce collectée
        this.score += 1 // Incrémenter le score de 5 points
        this.canvas.style.filter = 'blur(' + this.score + 'px)'

        if (Math.random() > 0.5) {
          this.canvas.style.transform = 'translate(-50%,-50%)rotate(' + this.score + 'deg)'
        } else {
          this.canvas.style.transform = 'translate(-50%,-50%)rotate(-' + this.score + 'deg)'
        }

        this.coins.push({
          x: this.canvas.width / 2 - this.roadWidth / 2 + Math.random() * (this.roadWidth - this.coinWidth),
          y: -Math.random() * this.obstacleGap
        })
      }
    })
  }

  drawScore () {
    this.ctx.font = '20px Space Grotesk'
    this.ctx.fillStyle = '#fff'
    this.ctx.fillText('Bières consommées : ' + this.score, 10, 30)
  }

  gameOver () {
    this.ctx.font = '40px Space Grotesk'
    this.ctx.fillStyle = '#FF0000'
    this.ctx.fillText('Game Over!', this.canvas.width / 4, this.canvas.height / 2)
    this.ctx.font = '20px Space Grotesk'
    this.ctx.fillStyle = '#FFF'
    document.getElementById('finalScore').innerText = 'Bières consommées: ' + this.score
    document.getElementById('gameOverScreen').style.display = 'block'
    this.canvas.style.display = 'none'
  }

  increaseDifficulty () {
    this.timeElapsed += 0.5 // Augmente le temps écoulé

    if (this.timeElapsed > 1000) {
      return
    }

    if (this.timeElapsed % 20 === 0) { // Chaque 20 unités de temps, augmenter la vitesse
      this.gameSpeed += 0.2
    }
  }

  gameLoop () {
    if (!this.isGameOver) {
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
      this.drawRoad()
      this.drawCar()
      this.drawObstacles()
      this.drawCoins()
      this.moveCar()
      this.moveObstacles()
      this.moveCoins()
      this.checkCollision()
      this.drawScore()
      this.increaseDifficulty()
      requestAnimationFrame(() => this.gameLoop())
    } else {
      this.gameOver()
    }
  }
}
